import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


export default function CardMetadata({ className, children, ...props }) {
  return (
    <div {...props} className={classNames(className, 'card-metadata')}>
      {children}
    </div>
  );
}

CardMetadata.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
